import {
  Typography,
  Paper,
  Switches,
  CardHeader,
  IconAvatar,
  PersonOutlineCheckedIcon,
} from '@occc-app/design-system';

export const AllowedForNewMembers = () => (
  <Paper>
    <CardHeader
      title={<Typography variant='subtitle1'>Allowed For New Members</Typography>}
      subheader={
        <Typography variant='body2' color='textSecondary'>
          Members can purchase this offer in the NEW_MEMBER status
        </Typography>
      }
      action={<Switches name='pointSpend.allowedForNewMember' data={{}} />}
      avatar={<IconAvatar Icon={PersonOutlineCheckedIcon} />}
      sx={{ py: 2, px: 3 }}
    />
  </Paper>
);
